import axios from 'axios'
const md5 = require('./md5.js')

// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    config.headers['sign'] = getSign(config.data)
    config.headers['accountId'] = 'ylsn_mini'
    return config
  },
  function (error) {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
  }
)

function getSign(postData) {
  let keys = Object.keys(postData).sort()
  // console.log(keys)
  let sign = ''
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    let value = postData[key]
    //value 中如果包含[] {} 不参与拼接 因为后台可能会当成json中的关键符号
    if (typeof value == 'string') {
      if (value.indexOf('[') != -1 && value.indexOf(']' != -1)) {
        continue
      }
      if (value.indexOf('{') != -1 && value.indexOf('}' != -1)) {
        continue
      }
    }
    //  debugger
    //value为空字符串或null或复杂结构的则不参与拼接计算
    if (value == null || value === '' || typeof value == 'undefined') {
      continue
    }
    if (Array.isArray(value)) {
      continue
    }
    sign = sign + key + '=' + value + '&'
  }
  sign = sign + 'salt=$2IMST90L#3Y71O^EWPVRAT8M14UB62Z'
  // console.log(sign)
  let signMd5 = md5(sign)
  // console.log(signMd5)
  return signMd5
}
function setL(value, expireTime, name) {
  // expireTime 毫秒级
  window.localStorage.setItem(
    name,
    JSON.stringify({
      data: value,
      expireTime
    })
  )
}

function getL(key, exp) {
  const data = localStorage.getItem(key)
  if (!data) return false
  const dataObj = JSON.parse(data)
  if (dataObj.expireTime - new Date().getTime() < 5000) {
    //提前5秒即过期 重新请求
    console.log('信息已过期')
    return false
  } else {
    return dataObj.data
  }
}

function clearL(name) {
  window.localStorage.removeItem(name)
}

function getUrlScheme(type, data) {
  let switchData = switchType(type, data)
  const u = getL(switchData.storageName)
  if (u && type !== 4) return goWXmini(u)
  const url = location.href
  const curTime = new Date().getTime()
  let requestBaseUrl = 'https://app-ylsn.ylyk.com' //默认正式
  // let requestBaseUrl = "http://172.18.6.194:8082"; //本地
  // let requestBaseUrl = "https://app-ylsn-test.ylyk.com"; //测试
  if (url.indexOf('test') >= 0) requestBaseUrl = 'https://app-ylsn-test.ylyk.com' //测试环境
  axios
    .post(requestBaseUrl + '/v1/mini/common/schema', {
      randomStr: curTime,
      pageCode: switchData.pageCode,
      envVersion: url.indexOf('test') >= 0 ? 'trial' : 'release',
      query: switchData.q
    })
    .then(
      res => {
        if (res.data.code == 0) {
          setL(res.data.data.schemaUrl, res.data.data.expireTime * 1000, switchData.storageName)
          goWXmini(res.data.data.schemaUrl)
        } else {
          alert(res.data.message)
        }
      },
      err => {
        console.log(err)
      }
    )
}

function goWXmini(jumpUrl) {
  location.href = jumpUrl
}
window.onerror = e => {
  console.error('-------', e)
}

function onErroe() {
  alert('发生错误,请手动点击跳转')
  clearL()
}

function switchType(type, data) {
  console.log(type, data, 'type, id')
  const params_type = type
  const params_id = data
  //默认领取权益
  let obj = {
    storageName: 'miniScheme',
    pageCode: 'mini_order_claim',
    q: ''
  }
  document.title = '领取权益'
  switch (params_type * 1) {
    case 1: //APP-添加班主任
      obj.storageName = 'adviseScheme'
      obj.pageCode = 'mini_add_advise'
      if (data) {
        if (data.userId) {
          obj.q = 'userId=' + data.userId
          obj.storageName = data.userId + 'adviseScheme'
        } else {
          obj.q = `adviserCode=${data.adviserCode}&goodsType=${data.goodsType}`
          obj.storageName = data.goodsId + 'adviseScheme'
        }
      }
      document.title = '添加班主任'
      break
    case 2: //云鹏
      obj.storageName = 'ypadviseScheme'
      obj.pageCode = 'mini_yp_add_advise'
      document.title = '云鹏会客厅'
      break
    case 3: //中文课
      obj.storageName = 'zh_cnAdviseScheme'
      obj.pageCode = 'mini_chinese_add_advise'
      document.title = '夏老师职场进阶课'
      break
    case 4: //APP-添加班主任-定向引流
      obj.storageName = 'adviseScheme'
      obj.pageCode = 'mini_add_advise'
      obj.q = 'id=' + params_id
      document.title = '添加班主任-定向引流'
      break
  }
  return obj
}

export default getUrlScheme
